const makerjs = require('makerjs')

import Frame from '@/js/cad/production/products/spiceRack/frame/Frame'
import Shelf from '@/js/cad/production/products/spiceRack/shelf/Shelf'
import Baton from '@/js/cad/production/products/spiceRack/baton/Baton'

export default class SpiceRack {
  constructor(spiceRack, materialThickness, materialID) {
    this.spiceRack = spiceRack
    this.materialThickness = materialThickness
    this.materialID = materialID

    // Shelf Info
    this.shelfInfo = {
      tSlotDepth: 13,
      widthLoss: 0.5, // amount shelf slopes inward
      shelfSetback: 2,
      notchSetback: 6.5,
      notchSquareDepth: 18.5,
      notchCutDepth: 9.5,
      notchWidth: 5,
      backRebateSetback: 4
    }

    // Baton Info
    this.batonInfo = {
      tSlotDepth: 13,
      batonHeight: 39,
      batonRebateToolDiameter: 8,
      batonRebateInset: 15,
      batonDrillGuideDiameter: 3,
      batonToWallDrillInset: 19
    }

    // Frame Info
    this.frameInfo = {
      dowelPocketDiameter: 10.5,
      dowelPocketInset: 9,
      dowelStartOffset: 26.25,
      dowelSmallSpacing: 43, // 32.5 + dowelPocketDiameter
      dowelLargeSpacing: 63, // 52.5 + dowelPocketDiameter
      finPocketTolerance: 0.5,
      tSlotLineGap: 5,
      tSlotInset: 14,
      tSlotTolerance: 0.7,
      tSlotToolDiameter: 30,
      batonPocketInset: 9,
      batonPocketToolDiameter: 12,
      baseShelfGap: 24,
      smallShelfGap: 192,
      largeShelfGap: 292,
      frameCornerRadius: 25
    }

    // create empty model json
    this.models = {
      frame: {},
      shelves: {},
      batons: {}
    }

    // Create all components (spice racks use single material for frame)
    if (this.spiceRack.frame?.id === materialID) {
      this.createFrame()
      this.createShelves()
      this.createBatons()
    }
  }

  createShelves() {
    this.models.shelves = new Shelf(this.spiceRack, this.materialThickness, this.shelfInfo)
  }

  createBatons() {
    this.models.batons = new Baton(this.spiceRack, this.materialThickness, this.batonInfo)
    // position batons to the left of the shelves
    makerjs.model.move(this.models.batons, [-this.spiceRack.w - 13, 0])
  }

  createFrame() {
    this.models.frame = new Frame(this.spiceRack, this.materialThickness, this.frameInfo)
    // position below the shelves
    const shelfWidth = this.spiceRack.w - (this.materialThickness - this.shelfInfo.tSlotDepth) * 2
    makerjs.model.move(this.models.frame, [-(this.spiceRack.h - shelfWidth), -this.spiceRack.d - 13])
  }
}
